export default __webpack_public_path__ + "static/media/Armband of Ardent Fire.d076d296.jpg";